var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fiscalTaxParameter.ratesVisible
    ? _c(
        "div",
        [
          _c("h6", { staticClass: "mb-1" }, [
            _vm._v(" " + _vm._s(_vm.$t("IBS Estadual")) + " "),
          ]),
          _c(
            "b-row",
            { staticClass: "mb-2" },
            [
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "tax-parameter-ibs-state-percent",
                      name: "tax-parameter-ibs-state-percent",
                      type: "text-percetage",
                      currency: "%",
                      precision: 5,
                      validation: "required|number|min:0.0000|max:1",
                      "validation-messages": Object.assign(
                        {},
                        _vm.mxGetTextPercentageValidationMessages
                      ),
                      label: _vm.$t(
                        "FISCAL_TAX_PARAMETER.LABEL.IBS_STATE_PERCENT"
                      ),
                    },
                    model: {
                      value: _vm.fiscalTaxParameter.ibsStatePercent,
                      callback: function ($$v) {
                        _vm.$set(_vm.fiscalTaxParameter, "ibsStatePercent", $$v)
                      },
                      expression: "fiscalTaxParameter.ibsStatePercent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "tax-parameter-ibs-state-reduction-percent",
                      name: "tax-parameter-ibs-state-reduction-percent",
                      type: "text-percetage",
                      currency: "%",
                      precision: 5,
                      validation: "required|number|min:0.0000|max:1",
                      "validation-messages": Object.assign(
                        {},
                        _vm.mxGetTextPercentageValidationMessages
                      ),
                      label: _vm.$t(
                        "FISCAL_TAX_PARAMETER.LABEL.IBS_STATE_REDUCTION_PERCENT"
                      ),
                    },
                    model: {
                      value: _vm.fiscalTaxParameter.ibsStateReductionPercent,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.fiscalTaxParameter,
                          "ibsStateReductionPercent",
                          $$v
                        )
                      },
                      expression: "fiscalTaxParameter.ibsStateReductionPercent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "tax-parameter-ibs-state-deferral-percent",
                      name: "tax-parameter-ibs-state-deferral-percent",
                      type: "text-percetage",
                      currency: "%",
                      precision: 5,
                      validation: "required|number|min:0.0000|max:1",
                      "validation-messages": Object.assign(
                        {},
                        _vm.mxGetTextPercentageValidationMessages
                      ),
                      label: _vm.$t(
                        "FISCAL_TAX_PARAMETER.LABEL.IBS_STATE_DEFERRAL_PERCENT"
                      ),
                    },
                    model: {
                      value: _vm.fiscalTaxParameter.ibsStateDeferralPercent,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.fiscalTaxParameter,
                          "ibsStateDeferralPercent",
                          $$v
                        )
                      },
                      expression: "fiscalTaxParameter.ibsStateDeferralPercent",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c("h6", { staticClass: "mb-1 mt-1" }, [
            _vm._v(" " + _vm._s(_vm.$t("IBS Municipal")) + " "),
          ]),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "tax-parameter-ibs-municipal-percent",
                      name: "tax-parameter-ibs-municipal-percent",
                      type: "text-percetage",
                      currency: "%",
                      precision: 5,
                      validation: "required|number|min:0.0000|max:1",
                      "validation-messages": Object.assign(
                        {},
                        _vm.mxGetTextPercentageValidationMessages
                      ),
                      label: _vm.$t(
                        "FISCAL_TAX_PARAMETER.LABEL.IBS_MUNICIPAL_PERCENT"
                      ),
                    },
                    model: {
                      value: _vm.fiscalTaxParameter.ibsMunicipalPercent,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.fiscalTaxParameter,
                          "ibsMunicipalPercent",
                          $$v
                        )
                      },
                      expression: "fiscalTaxParameter.ibsMunicipalPercent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "tax-parameter-ibs-municipal-reduction-percent",
                      name: "tax-parameter-ibs-municipal-reduction-percent",
                      type: "text-percetage",
                      currency: "%",
                      precision: 5,
                      validation: "required|number|min:0.0000|max:1",
                      "validation-messages": Object.assign(
                        {},
                        _vm.mxGetTextPercentageValidationMessages
                      ),
                      label: _vm.$t(
                        "FISCAL_TAX_PARAMETER.LABEL.IBS_MUNICIPAL_REDUCTION_PERCENT"
                      ),
                    },
                    model: {
                      value:
                        _vm.fiscalTaxParameter.ibsMunicipalReductionPercent,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.fiscalTaxParameter,
                          "ibsMunicipalReductionPercent",
                          $$v
                        )
                      },
                      expression:
                        "fiscalTaxParameter.ibsMunicipalReductionPercent",
                    },
                  }),
                ],
                1
              ),
              _c(
                "b-col",
                { attrs: { md: "4" } },
                [
                  _c("FormulateInput", {
                    staticClass: "required",
                    attrs: {
                      id: "tax-parameter-ibs-municipal-deferral-percent",
                      name: "tax-parameter-ibs-municipal-deferral-percent",
                      type: "text-percetage",
                      currency: "%",
                      precision: 5,
                      validation: "required|number|min:0.0000|max:1",
                      "validation-messages": Object.assign(
                        {},
                        _vm.mxGetTextPercentageValidationMessages
                      ),
                      label: _vm.$t(
                        "FISCAL_TAX_PARAMETER.LABEL.IBS_MUNICIPAL_DEFERRAL_PERCENT"
                      ),
                    },
                    model: {
                      value: _vm.fiscalTaxParameter.ibsMunicipalDeferralPercent,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.fiscalTaxParameter,
                          "ibsMunicipalDeferralPercent",
                          $$v
                        )
                      },
                      expression:
                        "fiscalTaxParameter.ibsMunicipalDeferralPercent",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }